export default "__VITE_ASSET__MrIjHe6C__"